import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import {
  IntroductionPage,
  LoginPage,
  RegisterPage,
  Error404Page,
  DashboardPage,
  FAQSPage,
  PaymentsPage,
  ProductsPage,
  ProfilePage,
  RequestABagPage,
  RequestsPage,
  TermsAndConditionsPage,
  LocationsPage,
  ItemsToBeReturnedPage,
  JoinOurCommunity,
  Thankyou,
  ForgotPassword,
  AuthFAQS,
  AuthTermsAndConditions,
  CreateNewPassword,
  Notifications,
  DropAtLocation,
  AddressDetails,
} from "./pages";
import "./App.css";
import Otp from "pages/otp";
import SendBags from "pages/sendBags";
import Pickup from "pages/sendBags/dhl/Pickup";
import ItemsDonatedToCharity from "pages/items-donated-to-charity";
import ShipmentType from "pages/sendBags/dhl/ShipmentType";
import PackageDetails from "pages/sendBags/dhl/PackageDetails";
import ShipmentDate from "pages/sendBags/dhl/ShipmentDate";
import ShipmentDhlMethod from "pages/sendBags/dhl/ShipmentDhlMethod";
import DhlDropLocation from "pages/sendBags/dhl/DhlDropLocation";
import ShipmentEmail from "pages/sendBags/dhl/ShipmentEmail";
import PrintLabel from "pages/sendBags/dhl/PrintLabel";
import LabelPrintingOptions from "pages/sendBags/dhl/LabelPrintingOptions";
import MyBalance from "pages/my-balance";

// Route wrappers
const PublicRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  return token ? <Navigate to="/dashboard" replace /> : children;
};

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" />} />

        {/* Public Routes */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          }
        />
        <Route
          path="/register"
          element={
            <PublicRoute>
              <RegisterPage />
            </PublicRoute>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          }
        />
        <Route
          path="/reset-password"
          element={
            <PublicRoute>
              <CreateNewPassword />
            </PublicRoute>
          }
        />
        <Route
          path="/auth-faqs"
          element={
            <PublicRoute>
              <AuthFAQS />
            </PublicRoute>
          }
        />
        <Route
          path="/auth-terms-and-conditions"
          element={
            <PublicRoute>
              <AuthTermsAndConditions />
            </PublicRoute>
          }
        />

        {/* Private Routes */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <DashboardPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <ProfilePage />
            </PrivateRoute>
          }
        />
        {/* <Route
          path="/payments"
          element={
            <PrivateRoute>
              <PaymentsPage />
            </PrivateRoute>
          }
        /> */}
        <Route
          path="/my-balance"
          element={
            <PrivateRoute>
              <MyBalance />
            </PrivateRoute>
          }
        />
        <Route
          path="/products"
          element={
            <PrivateRoute>
              <ProductsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/drop-off-locations"
          element={
            <PrivateRoute>
              <LocationsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/request-a-bag"
          element={
            <PrivateRoute>
              <RequestABagPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/send-a-bag"
          element={
            <PrivateRoute>
              <SendBags />
            </PrivateRoute>
          }
        />
        <Route
          path="/send-a-bag/drop-at-location"
          element={
            <PrivateRoute>
              <DropAtLocation />
            </PrivateRoute>
          }
        />
        <Route
          path="/send-a-bag/dhl/address-details"
          element={
            <PrivateRoute>
              <AddressDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/send-a-bag/dhl/shipment-type"
          element={
            <PrivateRoute>
              <ShipmentType />
            </PrivateRoute>
          }
        />
        <Route
          path="/send-a-bag/dhl/package-details"
          element={
            <PrivateRoute>
              <PackageDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/send-a-bag/dhl/shipment-date"
          element={
            <PrivateRoute>
              <ShipmentDate />
            </PrivateRoute>
          }
        />
        <Route
          path="/send-a-bag/dhl/pickup"
          element={
            <PrivateRoute>
              <Pickup />
            </PrivateRoute>
          }
        />
        <Route
          path="/send-a-bag/dhl/shipment-to-dhl"
          element={
            <PrivateRoute>
              <ShipmentDhlMethod />
            </PrivateRoute>
          }
        />
        <Route
          path="/send-a-bag/dhl/drop-at-location"
          element={
            <PrivateRoute>
              <DhlDropLocation />
            </PrivateRoute>
          }
        />
        <Route
          path="/send-a-bag/dhl/label-print"
          element={
            <PrivateRoute>
              <PrintLabel />
            </PrivateRoute>
          }
        />
        <Route
          path="/send-a-bag/dhl/label-printing-options"
          element={
            <PrivateRoute>
              <LabelPrintingOptions />
            </PrivateRoute>
          }
        />
        <Route
          path="/send-a-bag/dhl/email"
          element={
            <PrivateRoute>
              <ShipmentEmail />
            </PrivateRoute>
          }
        />
        <Route
          path="/requests"
          element={
            <PrivateRoute>
              <RequestsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/notifications"
          element={
            <PrivateRoute>
              <Notifications />
            </PrivateRoute>
          }
        />
        <Route
          path="/items-to-be-returned"
          element={
            <PrivateRoute>
              <ItemsToBeReturnedPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/items-donated-to-charity"
          element={
            <PrivateRoute>
              <ItemsDonatedToCharity />
            </PrivateRoute>
          }
        />

        {/* Publicly accessible pages */}
        <Route path="/introduction-page" element={<IntroductionPage />} />
        <Route path="/Join-our-community" element={<JoinOurCommunity />} />
        <Route path="/success" element={<Thankyou />} />
        <Route path="/verification" element={<Otp />} />
        <Route path="/faqs" element={<FAQSPage />} />
        <Route
          path="/terms-and-conditions"
          element={<TermsAndConditionsPage />}
        />

        {/* Catch-all */}
        <Route path="*" element={<Error404Page />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
